import { PipeTransform, Pipe } from '@angular/core';
import { AppConstantsService } from '../services/app-constants.service';
import { DsrActivity, NonDriveTimeType } from '@xpo-ltl/sdk-linehaulpayform';
import * as _ from 'lodash';
import { PayformPaidTypeCd } from '@xpo-ltl/sdk-common';

@Pipe({
  name: 'paidTimeOrDuration',
})
export class PaidTimeOrDurationPipe implements PipeTransform {
  private paid = 'Pay Time';
  private duration = 'Duration';

  constructor(private constants: AppConstantsService) {}

  transform(input: any): any {
    if (input && _.get(input, 'dsrPayformId', undefined)) {
      const activity = input as DsrActivity;
      const nonDrvTimeTypeId = _.get(activity, 'nonDriveTimeType.nonDrvTimeTypeId', undefined);
      if (nonDrvTimeTypeId) {
        const type = this.constants.nonDriveTimeTypes.find(x => x.nonDrvTimeTypeId === nonDrvTimeTypeId);
        return type && type.paidCd === PayformPaidTypeCd.PAID ? this.paid : this.duration;
      }
    } else if (input && _.get(input, 'nonDrvTimeTypeId', undefined)) {
      return input.paidCd === PayformPaidTypeCd.PAID ? this.paid : this.duration;
    }

    return this.paid;
  }
}
